import React from "react";
import ProfileBox from "~/components/profile/ProfileBox";
import { Margin } from "~/components/spacings";
import * as palette from "@govlaunch/palette";
import StoriesIcon from "~/components/icons/VendorProfile/StoriesIcon";
import { FormattedMessage } from "react-intl";

export default function NoVendorStoriesBox() {
  return (
    <ProfileBox>
      <div
        css={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 26,
        }}
      >
        <StoriesIcon width={33} height={33} color={palette.mediumGray} />
        <Margin ml={14}>
          <span
            css={{
              fontSize: 18,
              fontWeight: 500,
              color: palette.mediumGray,
            }}
          >
            <FormattedMessage defaultMessage="No Story Connections" id="NDqheh" />
          </span>
        </Margin>
      </div>
    </ProfileBox>
  );
}
